import { render, staticRenderFns } from "./productSliderItemAlt.vue?vue&type=template&id=4e99f839"
import script from "./productSliderItemAlt.vue?vue&type=script&lang=js"
export * from "./productSliderItemAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports